// context/WishlistDrawerContext/WishlistDrawerContext.tsx
import { createContext, useContext, useState, ReactNode } from 'react';

interface WishlistDrawerContextType {
  isOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
}

const WishlistDrawerContext = createContext<WishlistDrawerContextType | null>(null);

export const useWishlistDrawer = () => {
  const context = useContext(WishlistDrawerContext);
  if (!context) {
    throw new Error('useWishlistDrawer must be used within WishlistDrawerProvider');
  }

  return context;
};

export const WishlistDrawerProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openDrawer = () => setIsOpen(true);
  const closeDrawer = () => setIsOpen(false);

  return (
    <WishlistDrawerContext.Provider value={{ isOpen, openDrawer, closeDrawer }}>
      {children}
    </WishlistDrawerContext.Provider>
  );
};
